export const BreadcrumbStyles = {
  crumbStyles: { display: 'flex', alignItems: 'center' },
  iconStyles: { display: 'flex', color: 'rgba(0, 0, 0, 0.87)', fontSize: 20 },
}
